import $ from 'jquery';
export default $.ajax;
